export default {
    de: {
        openPositions: "offene-stellen",
        searchPlaceholder: "Stellenangebote durchsuchen",
        showFilters: "Filter anzeigen",
        workloadFilter: "Pensum wählen",
        workingHours: "Arbeitszeiten",
        position: "Position",
        workplace: "Standort wählen",
        workfield: "Fachbereich wählen",
        jobGroup: "Berufsgruppe wählen",
        frequentJobs: "Häufig gesuchte Stellen",
        resetFilters: "Filter zurücksetzen",
        jobAbo: "Job-Newsletter abonnieren",
        jobAboLink: "https://ohws.prospective.ch/public/v1/careercenter/1001134/jobabo?lang=de",
        field: "Bereich"
    },

    en: {
        openPositions: "open-positions",
        searchPlaceholder: "Search term",
        showFilters: "Show filters",
        workloadFilter: "Workload",
        workingHours: "Working hours",
        position: "Position",
        workplace: "Workplace",
        workfield: "Work field",
        jobGroup: "Professional Group",
        frequentJobs: "Frequent jobs",
        resetFilters: "Reset filtration",
        jobAbo: "Job-Newsletter subscription",
        jobAboLink: "https://stage.ohws.prospective.ch/public/v1/careercenter/1001134/jobabo?lang=en",
        field: "Field"
    }
}

